import {Component, Input} from '@angular/core';
import {FieldInfo} from '../../domain/field-builder.service';

@Component({
    selector: 'af-participant-details',
    standalone: false,
    templateUrl: './participant-details.component.html',
    styleUrl: './participant-details.component.scss',
})
export class ParticipantDetailsComponent {
    @Input() fields: FieldInfo[];
    @Input() label: string;

    hasExpandableChildren(fieldExpandable: FieldInfo): boolean {
        if (!Array.isArray(fieldExpandable.expandableValue)) {
            return false;
        }
        return fieldExpandable.expandableValue.some(field => !!field.fieldName && !!field.fieldValue);
    }
}
